// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tasks .main {
  color: beige;
  text-align: left;
}

.tasks {
  padding-left: 25px;
  overflow-y: scroll;
  height: 480px;
  margin-top: 14px;
}

.PostponeButton button {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #e1e1e1 !important;
  border-radius: 0 !important;
}

.myButtonWrapper {
  display: flex;
  float: right;
}

.PostponeButton button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.closeDetailsButton {
  margin-right: 5px;
}

.closeDetailsButton button {
  background-color: #555;
  color: #e1e1e1 !important;
  border-radius: 0 !important;
}

.closeDetailsButton button:hover {
  background-color: #313131;
}

.tasksortBy .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  transform-origin: 0% !important;
  transform: none !important;
  transition: none !important;
  margin-left: 10px !important;
  margin-top: 7px !important;
}

.active-date {
  border-color: #3686db !important;
  background-color: #282b30 !important;
}

.tasksortBy .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
  transform-origin: 0% !important;
  transform: none !important;
  transition: none !important;
  margin-left: 5px !important;
}

.tasksortBy .MuiFormControl-root {
  height: 32px !important;
  color: #ccc;
  border: 1px solid #ccc;
  width: 129px;
}

.tasksortBy .MuiFormControl-root .MuiInputBase-root {
  height: 40px !important;
  color: #ccc;
  background-color: #282b30;
  font-size: 14px;
  float: right;
}

.Tasks .tasksortBy {
  width: 100%;
  text-align: right;
  margin-top: 20px;
}

.Tasks .tasksortBy .MuiFormControl-root .MuiFormLabel-root {
  color: white !important;
  font-size: 13px !important;
}

.tasksortBy .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
  fill: #fff !important;
}

.tasksortBy
  .MuiFormControl-root
  .MuiInputBase-root
  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}

.date {
  font-size: 12px;
}

.addTaskTitle input {
  background-color: #282b30;
  width: 100%;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #fff;
}

.addTaskTitle select {
  background-color: #282b30;
  width: 102%;
  height: 36px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #7a7777;
}

.addTaskTitle select option:first-child {
  color: #7a7777 !important;
}

input{
    background-color: #1C1E24 !important;
    border: 1px solid #363942 !important;
    border-radius: 0 !important;
}

.cancelButton {
  background-color: #555 !important;
  color: #e1e1e1 !important;
  border-radius: 0 !important;
}

.cancelButton button{
    background-color: #555 !important;
    color: #e1e1e1 !important;
    border-radius: 0 !important;
    float: right !important;
}

.cancelButton:hover {
  background-color: #7c7b7b !important;
}

.addTaskButton {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #e1e1e1 !important;
  border-radius: 0 !important;
}

.addTaskButton:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.addTaskDetail textarea {
  background-color: #282b30;
  width: 100%;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.addTaskTitle .react-datepicker-wrapper {
  width: 100% !important;
}

.Tasks .calendar {
  padding-top: 20px;
}

.Tasks .space {
  width: 20px;
  margin: 20px;
  display: inline;
}

.Tasks .addNewTask {
  text-align: right;
  padding-right: 20px;
}

.Tasks .addNewTask button {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #e1e1e1;
  border-radius: 0;
  width: 180px;
  font-size: 14px;
}

.Tasks .addNewTask button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.Tasks .dataList ul {
  list-style-type: none;
  padding: 0;
}

.Tasks .dataList ul li {
  display: inline;
  padding: 10px;
  background-color: #777a84;
  width: 100% !important;
  border-right: 1px solid #313131;
}

.Tasks .dataList ul li a:last-child {
  cursor: not-allowed;
}

.Tasks .dataList ul li:first-child {
  background-color: #4996ee;
}

.Tasks .dataList ul li a {
  display: inline;
  text-decoration: none;
  color: #e1e1e1;
  width: 100% !important;
}

.Tasks .content table,
td,
th {
  border: 1px solid #282b30;
}

.Tasks .content table {
  color: #e1e1e1;
  margin-top: 40px;
  width: 50%;
  height: 200px;
  border-collapse: collapse;
  text-align: center;
}

.Tasks .content table td:first-child {
  background-color: #777a84;
}

.Tasks .content table tr:nth-child(2) {
  background-color: #777a84;
}

.Tasks .content table th {
  background-color: #4996ee;
}

.Tasks .content table th:first-child {
  background-color: #777a84;
}

.Tasks .content table td:second-child {
  background-color: #777a84;
}

.Tasks .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 15px !important;
}

.Tasks input {
  border: 1px solid #555 !important;
  height: 15px;
  color: #fff;
  margin-left: 12px;
}

.calendar-and-tasks .MuiOutlinedInput-root {
  border: none !important;
}

.Tasks nav ul {
  margin-top: 20px;
  cursor: pointer;
}

.Tasks .css-zow5z4-MuiGrid-root > .MuiGrid-item {
  padding: 0 !important;
}

.Tasks .App {
  height: auto;
}

.Tasks .task {
  max-height: 400px;
  overflow-y: scroll;
  padding-left: 20px;
  width: 100%;
}

.Tasks .react-calendar__month-view__days {
  height: 400px;
}

.Tasks .react-calendar__tile {
  background-color: #07070e;
  color: #e1e1e1;
  border: 1px solid #313131 !important;
  cursor: pointer;
}

.Tasks .react-calendar__year-view__months__month {
  height: 80px;
}

.Tasks .react-calendar__decade-view__years__year {
  height: 80px;
}

.Tasks .react-calendar__month-view__weekdays__weekday abbr[title] {
  color: #b8b8b8;
  text-decoration: none;
}

.Tasks .react-calendar__navigation button {
  background-color: #282b30;
  color: #e1e1e1;
  border: 1px solid #c9c9c9 !important;
  cursor: pointer;
  margin-bottom: 25px;
}

.task-dot {
  width: 30px;
  height: 30px;
  position: inherit;
  margin-bottom: -28px;
  border-radius: 50%;
  opacity: 0.5;
}

.task-dot .css-i4bv87-MuiSvgIcon-root {
  fill: #23f863;
}

.taskCard ul {
  list-style: none;
  padding: 0;
}

.taskCardTitle {
    font-size: 18px;
    font-weight: bold;

    max-height: 28px;
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.taskCardDetails {
  max-width: 240px;
  max-height: 15px;
  overflow: hidden;
  margin-bottom: 15px;
  font-size: 12px;
}

.taskCardDelete {
  text-align: right;
  display: inline;
  width: 50% !important;
  float: right;
}

.taskCard {
    color: #e1e1e1;
    padding: 15px;
    background-color: #282B30;
    margin-bottom: 20px;
    max-width: 90%;
    width: 90%;

}

.taskCardTag {
  border-radius: 60%;

  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.taskCardTag span {
  background-color: #e16162;
  border-radius: 60%;
  padding: 0 5px;
  align-items: center;
}

.hold {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

/* width */
.Tasks ::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #282b30;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #555;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.taskButtonContainer button {
  background-color: #9b9b9b;
  color: #e1e1e1;
  border-radius: 0;
  font-size: 10px;
  display: inline-block;
  margin: 0 10px 0 0;
}

.taskButtonContainer .viewtasksbutton {
  background-color: #e16162;
  color: #e1e1e1;
  border-radius: 0;
  font-size: 10px;
  display: inline-block;
  margin-left: 10px;
}

.calendar-and-tasks .MuiGrid-root input {
  background-color: #282b30;
  width: -webkit-fill-available;
  width: -moz-available;
  width: 100%;
  border-radius: 0 !important;
  border: 1px solid #555 !important;
  height: 30px;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: left;
  left: 0 !important;
}

.add-task-form button {
  border-radius: 0 !important;
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #fff;
  float: left;
  font-size: 10px;
  margin-left: 10px;
}

.add-task-form button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.add-notification-form {
  color: #e1e1e1;
}

.add-notification-form input {
  margin-top: 20px;
}

.add-notification-form button {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #e1e1e1;
  margin-left: 5px;
  border-radius: 0;
}

.add-notification-form button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}
.react-calendar__navigation {
  height: 10%;
}

.react-calendar__viewContainer {
  height: 90%;
}
#tilteNewAlert {
  width: 100%;
}

#detailsNewAlert {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  background-color: #282b30;
  color: #e1e1e1;
  margin-top: 20px;
}

.Tasks .alertMenuItem {
  width: 99%;
  text-align: center;
  color: #e1e1e1;
  height: 40px;
  background-color: #777a84;

  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
  position: relative;
}

.Tasks .alertMenuItem .activeLink {
  width: 100%;
  height: 40px;
  background-color: #4996ee;
}

.Tasks .alertMenuItem a {
  width: 100% !important;
  text-align: center;
  color: #282b30;
  text-decoration: none;
}

.Tasks .alertMenuItem .activeLink a {
  color: #e1e1e1;
}

.dataList .MuiGrid-item {
  padding: 0;
}

.margin-only {
  padding-top: 10px;
}

@media screen and (max-width: 899px) {
  .taskCard {
    max-width: 218px;
    width: 218px;
  }
}

@media screen and (max-width: 990px) and (min-width: 900px) {
  .taskCard {
    max-width: 157px;
    padding: 8px;
  }

  .taskButtonContainer button {
    font-size: 8px;
  }
}

@media screen and (max-width: 690px) and (min-width: 599px) {
  .taskCard {
    max-width: 177px;
    padding: 8px;
  }
}

@media screen and (max-width: 1060px) and (min-width: 900px) {
  .calendar-and-tasks .MuiGrid-root input {
    width: 85%;
  }
}

@media screen and (max-width: 600px) {
  .tasksortBy .MuiFormControl-root {
    width: 100%;
  }

  .Tasks input {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Tasks/tasks.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;;;;GAIC;EACD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAE/B,0BAA0B;EAE1B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAE/B,0BAA0B;EAE1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;;GAIC;EACD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,gBAAgB;IAChB,mBAAmB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,UAAU;;AAEd;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;;;;GAIC;AACH;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;;EAEzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".Tasks .main {\n  color: beige;\n  text-align: left;\n}\n\n.tasks {\n  padding-left: 25px;\n  overflow-y: scroll;\n  height: 480px;\n  margin-top: 14px;\n}\n\n.PostponeButton button {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #e1e1e1 !important;\n  border-radius: 0 !important;\n}\n\n.myButtonWrapper {\n  display: flex;\n  float: right;\n}\n\n.PostponeButton button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.closeDetailsButton {\n  margin-right: 5px;\n}\n\n.closeDetailsButton button {\n  background-color: #555;\n  color: #e1e1e1 !important;\n  border-radius: 0 !important;\n}\n\n.closeDetailsButton button:hover {\n  background-color: #313131;\n}\n\n.tasksortBy .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  transform-origin: 0% !important;\n  -webkit-transform: none !important;\n  transform: none !important;\n  -webkit-transition: none !important;\n  transition: none !important;\n  margin-left: 10px !important;\n  margin-top: 7px !important;\n}\n\n.active-date {\n  border-color: #3686db !important;\n  background-color: #282b30 !important;\n}\n\n.tasksortBy .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {\n  transform-origin: 0% !important;\n  -webkit-transform: none !important;\n  transform: none !important;\n  -webkit-transition: none !important;\n  transition: none !important;\n  margin-left: 5px !important;\n}\n\n.tasksortBy .MuiFormControl-root {\n  height: 32px !important;\n  color: #ccc;\n  border: 1px solid #ccc;\n  width: 129px;\n}\n\n.tasksortBy .MuiFormControl-root .MuiInputBase-root {\n  height: 40px !important;\n  color: #ccc;\n  background-color: #282b30;\n  font-size: 14px;\n  float: right;\n}\n\n.Tasks .tasksortBy {\n  width: 100%;\n  text-align: right;\n  margin-top: 20px;\n}\n\n.Tasks .tasksortBy .MuiFormControl-root .MuiFormLabel-root {\n  color: white !important;\n  font-size: 13px !important;\n}\n\n.tasksortBy .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n  fill: #fff !important;\n}\n\n.tasksortBy\n  .MuiFormControl-root\n  .MuiInputBase-root\n  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n\n.date {\n  font-size: 12px;\n}\n\n.addTaskTitle input {\n  background-color: #282b30;\n  width: 100%;\n  height: 30px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n.addTaskTitle select {\n  background-color: #282b30;\n  width: 102%;\n  height: 36px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  color: #7a7777;\n}\n\n.addTaskTitle select option:first-child {\n  color: #7a7777 !important;\n}\n\ninput{\n    background-color: #1C1E24 !important;\n    border: 1px solid #363942 !important;\n    border-radius: 0 !important;\n}\n\n.cancelButton {\n  background-color: #555 !important;\n  color: #e1e1e1 !important;\n  border-radius: 0 !important;\n}\n\n.cancelButton button{\n    background-color: #555 !important;\n    color: #e1e1e1 !important;\n    border-radius: 0 !important;\n    float: right !important;\n}\n\n.cancelButton:hover {\n  background-color: #7c7b7b !important;\n}\n\n.addTaskButton {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #e1e1e1 !important;\n  border-radius: 0 !important;\n}\n\n.addTaskButton:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.addTaskDetail textarea {\n  background-color: #282b30;\n  width: 100%;\n  color: #fff;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.addTaskTitle .react-datepicker-wrapper {\n  width: 100% !important;\n}\n\n.Tasks .calendar {\n  padding-top: 20px;\n}\n\n.Tasks .space {\n  width: 20px;\n  margin: 20px;\n  display: inline;\n}\n\n.Tasks .addNewTask {\n  text-align: right;\n  padding-right: 20px;\n}\n\n.Tasks .addNewTask button {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #e1e1e1;\n  border-radius: 0;\n  width: 180px;\n  font-size: 14px;\n}\n\n.Tasks .addNewTask button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.Tasks .dataList ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.Tasks .dataList ul li {\n  display: inline;\n  padding: 10px;\n  background-color: #777a84;\n  width: 100% !important;\n  border-right: 1px solid #313131;\n}\n\n.Tasks .dataList ul li a:last-child {\n  cursor: not-allowed;\n}\n\n.Tasks .dataList ul li:first-child {\n  background-color: #4996ee;\n}\n\n.Tasks .dataList ul li a {\n  display: inline;\n  text-decoration: none;\n  color: #e1e1e1;\n  width: 100% !important;\n}\n\n.Tasks .content table,\ntd,\nth {\n  border: 1px solid #282b30;\n}\n\n.Tasks .content table {\n  color: #e1e1e1;\n  margin-top: 40px;\n  width: 50%;\n  height: 200px;\n  border-collapse: collapse;\n  text-align: center;\n}\n\n.Tasks .content table td:first-child {\n  background-color: #777a84;\n}\n\n.Tasks .content table tr:nth-child(2) {\n  background-color: #777a84;\n}\n\n.Tasks .content table th {\n  background-color: #4996ee;\n}\n\n.Tasks .content table th:first-child {\n  background-color: #777a84;\n}\n\n.Tasks .content table td:second-child {\n  background-color: #777a84;\n}\n\n.Tasks .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 15px !important;\n}\n\n.Tasks input {\n  border: 1px solid #555 !important;\n  height: 15px;\n  color: #fff;\n  margin-left: 12px;\n}\n\n.calendar-and-tasks .MuiOutlinedInput-root {\n  border: none !important;\n}\n\n.Tasks nav ul {\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n.Tasks .css-zow5z4-MuiGrid-root > .MuiGrid-item {\n  padding: 0 !important;\n}\n\n.Tasks .App {\n  height: auto;\n}\n\n.Tasks .task {\n  max-height: 400px;\n  overflow-y: scroll;\n  padding-left: 20px;\n  width: 100%;\n}\n\n.Tasks .react-calendar__month-view__days {\n  height: 400px;\n}\n\n.Tasks .react-calendar__tile {\n  background-color: #07070e;\n  color: #e1e1e1;\n  border: 1px solid #313131 !important;\n  cursor: pointer;\n}\n\n.Tasks .react-calendar__year-view__months__month {\n  height: 80px;\n}\n\n.Tasks .react-calendar__decade-view__years__year {\n  height: 80px;\n}\n\n.Tasks .react-calendar__month-view__weekdays__weekday abbr[title] {\n  color: #b8b8b8;\n  text-decoration: none;\n}\n\n.Tasks .react-calendar__navigation button {\n  background-color: #282b30;\n  color: #e1e1e1;\n  border: 1px solid #c9c9c9 !important;\n  cursor: pointer;\n  margin-bottom: 25px;\n}\n\n.task-dot {\n  width: 30px;\n  height: 30px;\n  position: inherit;\n  margin-bottom: -28px;\n  border-radius: 50%;\n  opacity: 0.5;\n}\n\n.task-dot .css-i4bv87-MuiSvgIcon-root {\n  fill: #23f863;\n}\n\n.taskCard ul {\n  list-style: none;\n  padding: 0;\n}\n\n.taskCardTitle {\n    font-size: 18px;\n    font-weight: bold;\n\n    max-height: 28px;\n    white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.taskCardDetails {\n  max-width: 240px;\n  max-height: 15px;\n  overflow: hidden;\n  margin-bottom: 15px;\n  font-size: 12px;\n}\n\n.taskCardDelete {\n  text-align: right;\n  display: inline;\n  width: 50% !important;\n  float: right;\n}\n\n.taskCard {\n    color: #e1e1e1;\n    padding: 15px;\n    background-color: #282B30;\n    margin-bottom: 20px;\n    max-width: 90%;\n    width: 90%;\n\n}\n\n.taskCardTag {\n  border-radius: 60%;\n\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.taskCardTag span {\n  background-color: #e16162;\n  border-radius: 60%;\n  padding: 0 5px;\n  align-items: center;\n}\n\n.hold {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n/* width */\n.Tasks ::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #282b30;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #555;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.taskButtonContainer button {\n  background-color: #9b9b9b;\n  color: #e1e1e1;\n  border-radius: 0;\n  font-size: 10px;\n  display: inline-block;\n  margin: 0 10px 0 0;\n}\n\n.taskButtonContainer .viewtasksbutton {\n  background-color: #e16162;\n  color: #e1e1e1;\n  border-radius: 0;\n  font-size: 10px;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.calendar-and-tasks .MuiGrid-root input {\n  background-color: #282b30;\n  width: -webkit-fill-available;\n  width: -moz-available;\n  width: 100%;\n  border-radius: 0 !important;\n  border: 1px solid #555 !important;\n  height: 30px;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  text-align: left;\n  left: 0 !important;\n}\n\n.add-task-form button {\n  border-radius: 0 !important;\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #fff;\n  float: left;\n  font-size: 10px;\n  margin-left: 10px;\n}\n\n.add-task-form button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.add-notification-form {\n  color: #e1e1e1;\n}\n\n.add-notification-form input {\n  margin-top: 20px;\n}\n\n.add-notification-form button {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #e1e1e1;\n  margin-left: 5px;\n  border-radius: 0;\n}\n\n.add-notification-form button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n.react-calendar__navigation {\n  height: 10%;\n}\n\n.react-calendar__viewContainer {\n  height: 90%;\n}\n#tilteNewAlert {\n  width: 100%;\n}\n\n#detailsNewAlert {\n  width: 100%;\n  height: 200px;\n  margin-bottom: 20px;\n  background-color: #282b30;\n  color: #e1e1e1;\n  margin-top: 20px;\n}\n\n.Tasks .alertMenuItem {\n  width: 99%;\n  text-align: center;\n  color: #e1e1e1;\n  height: 40px;\n  background-color: #777a84;\n\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.Tasks .alertMenuItem .activeLink {\n  width: 100%;\n  height: 40px;\n  background-color: #4996ee;\n}\n\n.Tasks .alertMenuItem a {\n  width: 100% !important;\n  text-align: center;\n  color: #282b30;\n  text-decoration: none;\n}\n\n.Tasks .alertMenuItem .activeLink a {\n  color: #e1e1e1;\n}\n\n.dataList .MuiGrid-item {\n  padding: 0;\n}\n\n.margin-only {\n  padding-top: 10px;\n}\n\n@media screen and (max-width: 899px) {\n  .taskCard {\n    max-width: 218px;\n    width: 218px;\n  }\n}\n\n@media screen and (max-width: 990px) and (min-width: 900px) {\n  .taskCard {\n    max-width: 157px;\n    padding: 8px;\n  }\n\n  .taskButtonContainer button {\n    font-size: 8px;\n  }\n}\n\n@media screen and (max-width: 690px) and (min-width: 599px) {\n  .taskCard {\n    max-width: 177px;\n    padding: 8px;\n  }\n}\n\n@media screen and (max-width: 1060px) and (min-width: 900px) {\n  .calendar-and-tasks .MuiGrid-root input {\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .tasksortBy .MuiFormControl-root {\n    width: 100%;\n  }\n\n  .Tasks input {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
